module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "missionEmbedModal",
    attrs: {
      "id": "missionEmbedModal",
      "size": "lg",
      "title": _vm.$t('mission.modal.embed'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionEmbedInformation
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12 font-weight-bold",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.token'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.token.description'))
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12 text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedMissionToken)
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12 text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.generateMissionToken
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.generate')) + "\n          ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "danger",
      "disabled": _vm.missionToken === null
    },
    on: {
      "click": _vm.deleteMissionToken
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n          ")])], 1)])]), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission embed actions"
    }
  }, [_c('b-btn', {
    on: {
      "click": _vm.hideMissionEmbedModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.close')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30acfced"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionEmbedModal.vue
// module id = 492
// module chunks = 0